// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sm-input-long[data-v-75b8646a] {\n  float: right;\n  width: 35%;\n}\n@media (max-width: 750px) {\n.sm-input-long[data-v-75b8646a] {\n    width: 32%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
